import { sum } from 'd3';
import { interpolateHsl, interpolateRgb } from 'd3-interpolate';
import { scaleLinear } from 'd3-scale';
import { normalizeTaxEls } from '../helpers';
import { AFFILIATIONS, CITIES, WORLD_COUNTRIES } from './constants';
import { geoEquirectangular } from 'd3-geo';

const getProjection = (type) => {
	const projs = {
		equirectangular: geoEquirectangular(),
	};

	return projs[type];
};

const getColorScale = (colors, maxV, gamma = 2) => {
	return scaleLinear()
		.interpolate(interpolateRgb.gamma(gamma))
		.range([colors[0], colors[1]])
		.domain([0, maxV]);
};
const getHiddenColorScale = (maxV) => {
	return scaleLinear()
		.interpolate(interpolateHsl)
		.range(['magenta', 'cyan', 'yellow'])
		.domain([0, maxV]);
};

/**
 *
 * @param {*} countriesGeometries
 * @param {*} data
 * @return
 */
function getCountriesFromPosts(data) {
	const matchesPerCountry = {};
	for (const element of data) {
		const postsCats = element.categories.map((c) => c.name.toLowerCase());

		WORLD_COUNTRIES.objects.countries.geometries.forEach((f) => {
			const fCountry = f.properties.NAME;
			matchesPerCountry[fCountry] = matchesPerCountry[fCountry]
				? matchesPerCountry[fCountry]
				: 0;
			if (postsCats.includes(fCountry?.toLowerCase())) {
				matchesPerCountry[fCountry] += 1;
			}
		});
	}
	return matchesPerCountry;
}

function getPercentageFromCountriesVals(objArray) {
	const percentagePerElement = {};
	const maxVal = sum(objArray.map((o) => parseInt(o.value)));

	objArray.forEach((o) => {
		const percentage = parseInt(o.value) / maxVal;
		percentagePerElement[o.name] = parseFloat(percentage.toFixed(2));
	});

	return percentagePerElement;
}

function getValuesFromCountriesByContintents(data) {
	const arrayA = WORLD_COUNTRIES.objects.countries.geometries;
	const arrayB = data;

	const countriesByContinent = {};
	for (const objB of arrayB) {
		const matchedObject = arrayA.find(
			(objA) =>
				objA.properties.NAME === objB.name ||
				objA.properties.CONTINENT === objB.name
		);

		if (matchedObject) {
			const continent = matchedObject.properties.CONTINENT;

			if (!countriesByContinent[continent]) {
				countriesByContinent[continent] = 0;
			}

			countriesByContinent[continent] += parseInt(objB.value);
		}
	}
	return countriesByContinent;
}

function getPercentageFromContinentsObj(continentsValues) {
	const percentagePerElement = {};
	const maxVal = sum(Object.values(continentsValues));

	Object.entries(continentsValues).forEach(([k, v]) => {
		const percentage = v / maxVal;
		percentagePerElement[k] = parseFloat(percentage.toFixed(2));
	});

	return percentagePerElement;
}

const getCartogramDataFromTaxs = (taxonomies) => {
	let result = [];

	for (const [, terms] of Object.entries(taxonomies)) {
		result = result.concat(terms.map(normalizeTaxEls));
	}

	return result;
};

const getPOIs = (data) => {
	return data.filter((d) => {
		for (const f of WORLD_COUNTRIES.objects.countries.geometries) {
			const dName = d.name.toLowerCase().trim();
			const fName = f.properties.NAME.toLowerCase().trim();
			const cName = f.properties.CONTINENT;
			const matched = fName === dName || cName === dName;
			if (matched) return false;
		}
		return true;
	});
};

function getPOI(taxonomy, taxonomies = []) {
	const tName = taxonomy.name.toLowerCase().trim();

	for (const city of CITIES) {
		if (city.name.toLowerCase().trim() === tName) {
			return city;
		}
	}
	for (const affi of AFFILIATIONS) {
		if (affi.name.toLowerCase().trim() === tName) {
			return affi;
		}
	}
	for (const t of taxonomies) {
		if (t.id === taxonomy.parent) {
			return getPOI(t);
		}
	}
	// console.log('Not found POI', taxonomy);
}

function getPOIProjectedCoords(POI, projection) {
	const coords = projection([POI.coordinates[1], POI.coordinates[0]]);
	return coords;
}

export {
	getColorScale,
	getCountriesFromPosts,
	getPercentageFromCountriesVals,
	getCartogramDataFromTaxs,
	getProjection,
	getValuesFromCountriesByContintents,
	getPercentageFromContinentsObj,
	getPOIs,
	getPOI,
	getPOIProjectedCoords,
	getHiddenColorScale,
};
